/**
 * Baut das ToC als HTML mit 3-Span-Struktur:
 *   <a><span.toc-text>Text</span><span.toc-leader/><span.toc-page/></a>
 *
 * Die `.toc-page` bleibt initial leer; nach dem Paged.js-Render werden die
 * Seitenzahlen per JS aus dem Iframe-Script gefüllt (siehe pagedjsPreview.ts).
 * Das ist robuster als `target-counter(attr(href), page)` im CSS, das je nach
 * Polyfill-Version nicht durchläuft.
 */
export function buildTocHtml(headings, settings) {
    if (!settings.toc.enabled)
        return "";
    const filtered = headings.filter((h) => h.level <= settings.toc.depth);
    if (filtered.length === 0)
        return "";
    const items = filtered
        .map((h) => `<li class="toc-l${h.level}"><a href="#${h.id}"><span class="toc-text">${escapeHtml(h.text)}</span><span class="toc-leader"></span><span class="toc-page"></span></a></li>`)
        .join("\n");
    return `<nav class="toc" id="md2bp-toc">
    <h1 class="toc-title">${escapeHtml(settings.toc.title)}</h1>
    <ol class="toc-list">${items}</ol>
  </nav>`;
}
function escapeHtml(s) {
    return s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}
